<template>
  <section class="tables new-updated-design">
    <div class="container-property">
      <vue-snotify></vue-snotify>
      <div class="row">
        <div class="col-lg-12 grid-margin property-box-detail stretch-card">
          <div class="property-card px-3 px-md-0">
            <!-- <div class="card-header d-flex" style="justify-content: space-between;">
                <div>
                    <h4 class="card-title m-0">{{ $t('property_detail.Property_Detail') }}</h4>
                </div>
                <div>
                    
                </div>
            </div> -->
            <div class="card-body px-0">
              <div class="main-heading">
                <h3>
                  {{ $t("property_detail.Property_Images") }} 
                </h3>
              </div>
              <div class="row">
                  <div class="col-md-6">
                      <b-carousel
                        id="carousel-1"
                        v-model="currentSlide"
                        :interval="0"
                        controls
                        indicators
                        background="#111"
                        style="text-shadow: 1px 1px 2px #333; border-radius: 10px; overflow: hidden;"
                      >
                        <b-carousel-slide
                          v-for="(imagePreview, index) in propertyData.photos"
                          :key="index"
                        >
                          <template #img>
                            <img
                              :src="imagePreview.path"
                              alt="Preview"
                              class="d-block w-100"
                              style="height: 280px; object-fit: cover; object-position: center; border-radius: 10px;"
                            />
                          </template>
                        </b-carousel-slide>
                      </b-carousel>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="bar-chart mt-4 mt-md-0">
                      <bar-chart
                        :labels="labels"
                        :chartData="propertyData.chartData"
                      ></bar-chart>
                    </div>
                  </div>
              </div>
              <div class="row property-content">
                <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                  <div>
                      <p v-if="propertyData.approve">
                          <span class="font-weight-bolder mr-1"
                            >{{ $t("property_detail.Status") }}:</span
                          >{{ $t("property_detail.approved") }}
                        </p>
                        <p v-else>
                          <span class="font-weight-bolder mr-1"
                            >{{ $t("property_detail.Status") }}:</span
                          >{{ $t("Not Approved") }}
                        </p>
                  </div>
                  <p>
                    <span class="font-weight-bolder"
                      >{{ $t("properties_list.Property_Type") }}:</span
                    >
                    {{ propertyData.accommodation_type }} ({{ $t('property_detail.' + propertyData.property_type) }})
                  </p>
                  <p>
                    <span class="font-weight-bolder"
                      >{{ $t("properties_list.city") }}:</span
                    >
                    {{ propertyData.city }}
                  </p>
                  <p v-if="propertyData.state">
                    <span class="font-weight-bolder"
                      >{{ $t("properties_list.state") }}:</span
                    >
                    {{ propertyData.state }}
                  </p>
                  <p>
                    <span class="font-weight-bolder"
                      >{{ $t("property_detail.Country") }}:</span
                    >
                    {{ propertyData.country }}
                  </p>
                  <p>
                    <span class="font-weight-bolder"
                      >{{ $t("property_detail.Guests") }}:</span
                    >
                    {{ propertyData.max_guests }}
                  </p>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                  <p>
                    <span class="font-weight-bolder"
                      >{{ $t("property_detail.bedrooms") }}:</span
                    >
                    {{ propertyData.num_bedrooms }}
                  </p>
                  <p>
                    <span class="font-weight-bolder"
                      >{{ $t("property_detail.Bedroom_Amenities") }}:</span
                    >
                    {{ bedroomAmenitiesDisplay }}
                  </p>
                  <p>
                    <span class="font-weight-bolder"
                      >{{ $t("property_detail.bathrooms") }}:</span
                    >
                    {{ propertyData.num_bathrooms }}
                  </p>
                  <p>
                    <span class="font-weight-bolder"
                      >{{ $t("property_detail.Bathroom_Amenities") }}:</span
                    >
                    {{ bathroomAmenitiesDisplay }}
                  </p>
                  <p>
                    <span class="font-weight-bolder"
                      >{{ $t("property_detail.Price") }}:</span
                    >
                    ${{ propertyData.price_per_month }}
                  </p>
                </div>
                <div class="col-lg-6 col-md-4 col-sm-6 mb-3">
                  <p>
                    <span class="font-weight-bolder"
                      >{{ $t("property_detail.wifi") }}:</span
                    >
                    {{ propertyData.wifi_available === 1 ? "Yes" : "No" }}
                  </p>
                  <p>
                    <span class="font-weight-bolder"
                      >{{ $t("property_detail.kitchen") }}:</span
                    >
                    {{ propertyData.kitchen_available === 1 ? "Yes" : "No" }}
                  </p>
                  <p>
                    <span class="font-weight-bolder"
                      >{{ $t("property_detail.tv") }}:</span
                    >
                    {{ propertyData.tv_available === 1 ? "Yes" : "No" }}
                  </p>
                  <p>
                    <span class="font-weight-bolder"
                      >{{ $t("property_detail.Description") }}:</span
                    >
                    {{ propertyData.property_description }}
                  </p>
                </div>
                
              </div>
              <b-button
                size="sm"
                @click="editProperty()"
                class="mr-1 edit-btn btn-info text-white"
              >
                {{ $t("properties_list.Edit") }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import Vue from "vue";
  import API from "@/api";
  import BarChart from "../components/charts/chartjs/barChart.vue";

  export default {
    name: "property_details",
    data() {
      return {
        currentSlide: 0,
        propertyData: {
          city: "",
          state: "",
          country: "",
          price: "",
          max_guests: "",
          num_bedrooms: "",
          num_bathrooms: "",
          propertyType: "",
          wifiAvailable: "",
          kitchen: "",
          tv: "",
          description: "",
          imagePreviews: [],
          id: "",
          approve: ""
        },
        slide: [],
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ]
      };
    },
    methods: {
      getProperty() {
        const id = sessionStorage.getItem("propertyId");
        API.getProperty(
          id,
          res => {
            this.propertyData = res.data.data;
            const labels = [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec"
            ];
            let data = [];
            res.data.chartData.forEach(val => {
              labels.forEach((label, index) => {
                if (val.month === label) {
                  data[index] = Math.round(val.data);
                } else {
                  data[index] = 0;
                }
              });
            });
            this.propertyData.chartData = data;
          },
          err => {
            console.log(err);
          }
        );
      },
      editProperty() {
        const id = sessionStorage.getItem("propertyId");
        this.$router.push({
          name: "add_property",
          params: { id: id, data: this.propertyData }
        });
      },
      onSlideStart(index) {
        this.slide[index] = 0;
      },
      onSlideEnd(index) {
        this.slide[index] = this.prperties[index].photos.length - 1;
      },
      approveProperty(id) {
        API.approveProperty(
          id,
          res => {
            if (res.status == 200) {
              this.propertyData.approve = 1;
              this.$swal({
                icon: "success",
                type: "success",
                title: "Success",
                text: res.data.message
              });
            } else {
              this.$swal({
                icon: "error",
                type: "error",
                title: "Oops...",
                text: res.message
              });
            }
          },
          err => {
            console.log(err);
          }
        );
      }
    },

    mounted() {
      this.getProperty();
    },
    components: {
      BarChart
    },
    computed: {
      bathroomAmenitiesDisplay() {
        if (Array.isArray(this.propertyData.bathroom_Amenities)) {
          return this.propertyData.bathroom_Amenities
            .map(amenity => this.$t("property_detail." + amenity))
            .join(", ");
        } else if (typeof this.propertyData.bathroom_Amenities === "string") {
          try {
            const parsedAmenities = JSON.parse(
              this.propertyData.bathroom_Amenities
            );
            if (Array.isArray(parsedAmenities)) {
              return parsedAmenities
                .map(amenity => this.$t("property_detail." + amenity))
                .join(", ");
            }
          } catch (error) {
            console.error("Error parsing bathroom amenities:", error);
          }
        }
        return this.propertyData.bathroom_Amenities;
      },
      bedroomAmenitiesDisplay() {
        if (Array.isArray(this.propertyData.bedroom_Amenities)) {
          if (this.propertyData.bedroom_Amenities.length === 0) {
            console.log("Empty array detected");
            return " ";
          }
          return this.propertyData.bedroom_Amenities
            .map(amenity => this.$t("property_detail." + amenity))
            .join(", ");
        } else if (typeof this.propertyData.bedroom_Amenities === "string") {
          try {
            const parsedAmenities = JSON.parse(
              this.propertyData.bedroom_Amenities
            );
            if (Array.isArray(parsedAmenities)) {
              if (parsedAmenities.length === 0) {
                console.log("Empty array detected after parsing");
                return " ";
              }
              return parsedAmenities
                .map(amenity => this.$t("property_detail." + amenity))
                .join(", ");
            }
          } catch (error) {
            console.error("Error parsing bedroom amenities:", error);
          }
        }
        return this.propertyData.bedroom_Amenities;
      }
    },
    created() {
      if (this.$route.params.id) {
        sessionStorage.setItem("propertyId", this.$route.params.id);
      }
    }
  };
</script>
<style>
  .bar-chart {
    width: 100%;
  }
  .property-card .main-heading {
    margin-bottom: 25px;
  }
  .property-card .main-heading h3{
    font-size: 22px;
    line-height: 1.2;
  }
  .property-box-detail .carousel {
    border: 1px solid #cccccc;
    border-radius: 20px !important;
    overflow: hidden;
  }
  .property-box-detail .carousel .carousel-inner .carousel-item img {
    height: auto !important;
    object-fit: cover !important;
    max-height: 500px;
  }
  /* .b-carousel img,
  .carousel .carousel-inner .carousel-item img {
    height: auto !important;
    object-fit: contain !important;
    max-height: 500px;
  } */
  .text-row p {
    font-size: 16px;
  }
  .bar-chart {
    color: #ff0000; 
  }
  .property-card {
    width: 100%;
  }
  .property-content {
    margin-top: 30px;
  }
  .property-content p {
    color: #717171;
    font-size: 14px;
    margin-bottom: 15px;
  }
  .property-content p span {
    color: #333;
  }
  button.edit-btn.btn-info {
    min-width: 120px;
    border-radius: 10px !important;
    font-size: 16px !important;
  }
</style>
